import { Box, Grid } from "@mui/material";
import SectionTitle from "../components/SectionTitle";
import FeatureCard from "../components/FeatureCard";

const features = [
  "Boosts Soil Fertility",
  "Healthy Root Development",
  "Moisture Retention",
  "Disease Resistance",
  "Natural Pest Defense",
  "Microbial Growth"
];

export default function UsesBenefits() {
  return (
    <Box px={8} py={10}>
      <SectionTitle
        title="Uses & Benefits"
        subtitle="Why organic farming matters"
      />

      <Grid container spacing={4} mt={4}>
        {features.map((f) => (
          <Grid item xs={12} md={4} key={f}>
            <FeatureCard title={f} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
